import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)

let modules = {}
const modulesContext = require.context('./modules', true, /.js$/)
modulesContext.keys().map(key => {
  // console.log(key)
  let fileName = key.split('/')[1]
  let module = modulesContext(key).default
  // console.log(module)
  if (!module.namespace) throw new Error('请定义' + fileName + '的namespace属性')

  module.namespaced = true // 必须要有，否则getter拿不到
  modules[module.namespace] = module
})
// console.log(modules)
export default new Vuex.Store({
  modules: {
    ...modules
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js